<template>
  <div class="drawer-content">
    <a-drawer
      :width="750"
      @close="rightDrawerClose"
      :visible="drawerVisibleFlag"
    >
      <div slot="title">
        {{ drawerTitle }}
        &emsp;<a-tag color="cyan" v-if="addInfo.detailName !== undefined">{{
          addInfo.detailName
        }}</a-tag>
      </div>
      <a-form :form="form" class="drawForm" layout="horizontal">
        <a-form-item
          label="营养套餐名称"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 12 }"
        >
          <a-input
            placeholder="请输入营养套餐名称"
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '营养套餐名称不能为空!' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="就餐类型"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 12 }"
        >
          <a-select
            placeholder="请选择就餐类型"
            mode="multiple"
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '就餐类型不能为空!' }]
              }
            ]"
          >
            <a-select-option value="1">早餐</a-select-option>
            <a-select-option value="2">午餐</a-select-option>
            <a-select-option value="3">晚餐</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="是否启用"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 12 }"
        >
          <a-switch
            checkedChildren="启用"
            unCheckedChildren="停用"
            :checked="swichFlag"
            @change="onChangeSwitch"
          />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 12 }"
        >
          <a-input placeholder="备注" v-decorator="['remark', { rules: [] }]" />
        </a-form-item>
        <a-form-item
          v-if="addInfo.form !== undefined && addInfo.form.id !== undefined"
        >
          <a-input type="hidden" v-decorator="['id', { rules: [] }]"></a-input>
        </a-form-item>
      </a-form>
      <!-- content -->
      <a-table
        :columns="columns"
        :dataSource="drawerMenuListData"
        :pagination="false"
        :loading="tableLoading"
      >
        <template
          v-for="(col, i) in ['name', 'img', 'menuCount']"
          :slot="col"
          slot-scope="text, record"
        >
          <!-- table -->
          <template v-if="col === 'name'">
            <food-select
              :key="col"
              v-if="record.editable"
              :defaultValue="foodSelectDDefaaultVal"
              @select="handleMenuSelect(record.key, arguments)"
            ></food-select>
            <template v-else>{{ text }}</template>
          </template>
          <template v-else-if="col === 'img'">
            <a-avatar
              :key="col"
              shape="square"
              :src="text ? text : 'images/noImg.jpg'"
            />
          </template>
          <template v-else-if="col === 'menuCount'">
            <a-input
              :key="col"
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              :placeholder="columns[i].title"
              @change="e => handleWeightChange(e.target.value, record.key, col)"
            />
            <template v-else>{{ text }}</template>
          </template>
        </template>
        <template slot="operation" slot-scope="text, record">
          <template v-if="record.editable">
            <span v-if="record.isNew">
              <a @click="saveRow(record)">添加</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="removeRow(record)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a @click="saveRow(record)">保存</a>
              <a-divider type="vertical" />
              <a @click="cancel(record.key)">取消</a>
            </span>
          </template>
          <span v-else>
            <a @click="editRow(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="是否要删除此行？" @confirm="removeRow(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </template>
      </a-table>
      <a-button
        style="width: 100%; margin-top: 16px; margin-bottom: 8px"
        type="dashed"
        icon="plus"
        @click="newPublishMenu"
        >新增菜品</a-button
      >
      <p class="tipContent">
        <a-tag color="green" v-if="tipState === 1">{{ tipAnalysis }}</a-tag>
        <a-tag color="orange" v-if="tipState === 2">{{ tipAnalysis }}</a-tag>
        <a-tag color="green" v-if="tipState === 1">{{ tipMessage }}</a-tag>
        <a-tag color="orange" v-if="tipState === 2">{{ tipMessage }}</a-tag>
      </p>
      <!-- footer -->
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right'
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="rightDrawerClose">
          取消
        </a-button>
        <a-button
          type="primary"
          @click="rightDrawSubmit"
          :loading="rightDrawSubmitLoading"
          >提交</a-button
        >
      </div>
    </a-drawer>
  </div>
</template>

<script>
import axios from 'axios'
import foodSelect from './food-select'
import { arrIsRepeat } from '@/utils/base'
import { addNutritionPackage, editNutritionPackage, checkChoosedMenus } from '@/apis/nutritionDishes'

const columns = [{
  title: '#',
  dataIndex: 'index',
  key: 'index',
  width: '60px',
  scopedSlots: { customRender: 'index' }
}, {
  title: '菜品名称',
  dataIndex: 'name',
  key: 'name',
  width: '150px',
  scopedSlots: { customRender: 'name' }
}, {
  title: '图片',
  dataIndex: 'img',
  key: 'img',
  scopedSlots: { customRender: 'img' }
},
{
  title: '描述',
  dataIndex: 'desc',
  key: 'desc',
  width: '100px'
},
{
  title: '份数',
  dataIndex: 'menuCount',
  key: 'menuCount',
  width: '100px',
  scopedSlots: { customRender: 'menuCount' }
},
{
  title: '操作',
  key: 'action',
  width: '110px',
  scopedSlots: { customRender: 'operation' }
}]

export default {
  data () {
    return {
      columns,
      drawerTitle: '添加营养套餐',
      tableLoading: false,
      foodSelectDDefaaultVal: '',
      rightDrawSubmitLoading: false,
      drawerMenuListData: [],
      swichFlag: true,
      tipMessage: '',
      tipAnalysis: '',
      tipState: 0
    }
  },
  props: {
    drawerVisibleFlag: {
      type: Boolean,
      default: false
    },
    menuId: {
      type: Number
    },
    isEdit: {
      type: String,
      default: 'add'
    },
    addInfo: {
      type: Object,
      default: () => { }
    }
  },
  methods: {
    onChangeSwitch (checked) {
      setTimeout(() => {
        this.swichFlag = checked
      })
    },
    // 关闭右侧抽屉
    rightDrawerClose () {
      this.drawerMenuListData = []
      this.$emit('close')
    },
    // 新增一条Item
    newPublishMenu () {
      const length = this.drawerMenuListData.length
      this.drawerMenuListData.push({
        key: length === 0 ? '1' : (parseInt(this.drawerMenuListData[length - 1].key) + 1).toString(),
        index: length === 0 ? 1 : (parseInt(this.drawerMenuListData[length - 1].key) + 1),
        menuId: 0,
        name: '',
        desc: '-',
        img: '',
        menuCount: 1,
        isNew: true,
        editable: true
      })
      this.foodSelectDDefaaultVal = ''
    },
    // 删除item
    removeRow (record) {
      const key = record.key
      let newData = this.drawerMenuListData.filter(item => item.key !== key)
      this.handleArrayIndexNumber(newData)
      this.drawerMenuListData = newData
    },
    handleArrayIndexNumber (arr) {
      arr.forEach((item, index) => {
        item.index = index + 1
      })
    },
    // 保存item
    saveRow (record) {
      const { key, menuId, menuCount } = record
      if (!menuId || !menuCount) {
        this.$message.warning('请填写完整信息！')
        return
      }
      if (!/(^[0-9](\d+)?(\.\d{1,3})?$)|(^\d\.\d{1,3}$)/.test(menuCount)) {
        this.$message.warning('重量格式不正确！')
        return
      }

      let that = this
      function _callBack () {
        const target = that.drawerMenuListData.filter(item => item.key === key)[0]
        target.editable = false
        target.isNew = false
      }
      _callBack()
    },
    // 保存或编辑
    editRow (record) {
      this.foodSelectDDefaaultVal = record.name
      const target = this.drawerMenuListData.filter(item => item.key === record.key)[0]
      target.editable = !target.editable
    },
    getRowByKey (key, newData) {
      const data = this.drawerMenuListData
      return (newData || data).filter(item => item.key === key)[0]
    },
    // 取消
    cancel (key) {
      const target = this.drawerMenuListData.filter(item => item.key === key)[0]
      target.editable = false
    },
    // 处理
    handleWeightChange (value, key, column) {
      const newData = [...this.drawerMenuListData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target[column] = value
        this.drawerMenuListData = newData
      }
    },
    // 菜品下拉选中
    handleMenuSelect (key, args) {
      const item = args[0]
      const currentEditObj = this.drawerMenuListData[this.drawerMenuListData.findIndex((value) => { return value.key === key })]
      currentEditObj.name = item.name
      currentEditObj.menuId = item.id
      currentEditObj.img = item.imgUrl
      currentEditObj.desc = item.describe
    },
    // 添加营养套餐提交
    rightDrawSubmit () {
      this.form.validateFields(
        (err, values) => {
          if (!err) {
            if (this.drawerMenuListData.length === 0) {
              this.$message.warning('请先添加菜品')
            } else {
              const errorData = this.drawerMenuListData.filter(item => item.isNew || item.editable)
              if (errorData.length) {
                this.$message.warning('请先完成菜品的添加与修改')
                return
              }

              let data = {
                name: values.name,
                PublicMenuType: values.type.join(','),
                isEnable: this.swichFlag,
                remark: values.remark,
                list: []
              }
              const tempMenuIds = [] // 接收menuId
              this.drawerMenuListData.forEach((item) => {
                tempMenuIds.push(item.menuId)
                data.list.push({
                  id: item.menuId,
                  count: item.menuCount
                })
              })

              if (arrIsRepeat(tempMenuIds)) {
                this.$message.warning('列表中包含相同菜品，请检查后再提交')
                return
              }
              this.rightDrawSubmitLoading = true
              // 提交
              let addOrEditSubmit = () => {
                if (this.isEdit === 'add') {
                  addNutritionPackage({ list: JSON.stringify(data) }).then(
                    res => {
                      this.rightDrawSubmitLoading = false
                      if (res.data.state === 1) {
                        this.$message.success('提交成功')

                        this.$emit('rightDrawSubmit')
                        setTimeout(() => {
                          this.tipMessage = ''
                          this.tipAnalysis = ''
                          this.tipState = 0
                        }, 100)
                      }
                    }
                  )
                } else if (this.isEdit === 'edit') {
                  data.id = values.id
                  editNutritionPackage({ list: JSON.stringify(data) }).then(
                    res => {
                      this.rightDrawSubmitLoading = false
                      if (res.data.state === 1) {
                        this.$message.success('修改成功')
                        setTimeout(() => {
                          this.tipMessage = ''
                          this.tipAnalysis = ''
                          this.tipState = 0
                        }, 100)
                        this.$emit('rightDrawSubmit')
                      }
                    }
                  )
                }
              }
              if (this.tipState !== 1) {
                const typeArr = values.type
                let promiseList = []
                for (let i = 0; i < typeArr.length; i++) {
                  promiseList.push(checkChoosedMenus({
                    menuIds: JSON.stringify(data.list),
                    type: typeArr[i]
                  }))
                }
                axios.all(promiseList).then(res => {
                  console.log(res)

                  for (let i = 0; i < res.length; i++) {
                    const result = res[i].data.attribute
                    this.tipMessage = result.reason
                    this.tipState = result.state
                    this.tipAnalysis = result.analysis
                    this.rightDrawSubmitLoading = false

                    if (result.state !== 1) {
                      this.$message.warning('您的营养套餐搭配不合理，请根据分析与建议检查后再次提交。')
                      break
                    }
                    addOrEditSubmit()
                  }
                })
              } else {
                addOrEditSubmit()
              }
            }
          }
        }
      )
    }

  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  components: {
    foodSelect
  },
  watch: {
    isEdit: function (data) {
      setTimeout(() => {
        this.form.setFieldsValue(this.addInfo.form)
      })
      if (data === 'edit') {
        this.drawerTitle = '修改营养套餐'
        this.swichFlag = this.addInfo.isEnable === 'true'
        this.drawerMenuListData = this.addInfo.list
      } else {
        this.drawerTitle = '添加营养套餐'
        this.swichFlag = true
        this.drawerMenuListData = []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.drawForm /deep/ .ant-form-item-label label {
  float: right;
}
.drawForm /deep/ .ant-row.ant-form-item {
  margin-bottom: 20px;
}
.tipContent /deep/ .ant-tag {
  display: block;
  height: auto;
  white-space: normal;
  margin-top: 5px;
  margin-right: 0;
  padding: 2px 5px;
}
</style>

<style lang="less">
.ant-drawer-body {
  max-height: calc(100% - 108px);
  overflow-y: scroll;
}
</style>
